// core
import { Component, Input, OnInit } from '@angular/core';

// campfire
import { MatDialog } from '@campfire-nx/material';
import { PartnerBrandService } from '@campfire-nx/api';

import * as constant from '../../../core/constants/refer.constants';

@Component({
  selector: 'app-refer-generic-travel',
  templateUrl: './refer-generic-travel.component.html',
  styleUrls: ['./refer-generic-travel.component.scss']
})
export class ReferGenericTravelComponent implements OnInit {
  @Input() quote!: any;
  pageComponents: any;
  currency!: string;
  precision: number = 2;

  constructor(
    private partnerBrandService: PartnerBrandService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.pageComponents = constant['travel'].components;
    this.currency = this.partnerBrandService.getCurrencySymbol();
  }

  startQuote(){
    window.location.href = `/quote/${this.quote.uuid}`;
  }
}